import * as React from 'react';
import { useRecoilValue } from 'recoil';
import TooltipComponent from '../../TooltipComponent';
import { customerSelector } from '../TripsOverviewState';

interface ICustomerProps {
  id: string;
  isAdditional?: boolean;
  datacyIndex: number;
}

function CustomerCell(props: ICustomerProps) {
  const customer = useRecoilValue(customerSelector(props.id));
  const renderRecords = () => {
    return (
      <div style={{ color: '#fff', whiteSpace: 'nowrap' }}>
        {(customer && customer.name) || '-'}
      </div>
    );
  };

  return props.isAdditional ? (
    // <TooltipComponent overlay={renderRecords()} width="auto">
    //   <div className="text-truncate">
    //     <a href="#" className="text-black">
    //       {(customer && customer.label) || '-'}
    //     </a>
    //   </div>
    // </TooltipComponent>
    <div className="text-truncate" data-cy={`row-${props.datacyIndex + 1}-customer`}>
      {(customer && customer.name) || '-'}
    </div>
  ) : (
    <div className="align-middle text-right" style={{ minWidth: '100px', flex: 1 }}>
      <TooltipComponent id={props.id} overlay={renderRecords()} width="auto">
        <div className="text-truncate" data-cy={`row-${props.datacyIndex + 1}-customer`}>
          <a href="#" className="text-black">
            {(customer && customer.label) || '-'}
          </a>
        </div>
      </TooltipComponent>
    </div>
  );
}

export default React.memo(CustomerCell);
